export default __webpack_public_path__ + "static/media/assure2.bb593b8d.png";